import { useMutation } from '@/hooks/use-api';
import resetPasswordApi from '@/api/patch/user/reset-password';
import Alert from '@/components/alert/alert-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import Link from '@/components/link/link-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { Heading1Text } from '@/utils/global-fonts';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import UpdatePasswordForm from './update-password-form';

/**
 * Update Password page.
 * @returns {JSX.Element} The rendered UpdatePassword page.
 */
const UpdatePassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [resetPassword, { loading: resetLoading }] =
    useMutation(resetPasswordApi);

  return (
    <PageWrapper>
      <BackContainer>
        <BackIcon fontSize="20px" mr="12px" />
        <Link to="/login">Back</Link>
      </BackContainer>
      <Heading1Text>Update Password</Heading1Text>
      <FormWrapper
        defaultValues={{
          password: '',
          confirmPassword: '',
        }}
        onSubmit={(submitData) => {
          resetPassword(token, submitData).then(() => {
            Alert({
              icon: 'success',
              text: 'Password successfully updated.',
            });
            navigate('/login');
          });
        }}
      >
        <UpdatePasswordForm loading={resetLoading} />
      </FormWrapper>
    </PageWrapper>
  );
};

const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`;
const BackIcon = styled(FiChevronLeft)`
  margin-right: ${({ mr }) => mr};
  font-size: ${({ fontSize }) => fontSize};
`;

export default UpdatePassword;
